import { $ } from "../../../common/scripts/Libs";

class AnimatedCounter {
    constructor(target) {
        this.el = $(target);
        this.oTop;
        this.window = $(window);
        this.isRun = false;
        this.initialValue = 0;
        this.value;
        this.initialWidth;
    }

    startAnimation() {
        this.isRun = true;
        const endValue = parseInt(this.value.replace(/,/g, ''));
        this.el.prop('Counter', this.initialValue).animate(
            { Counter: endValue },
            {
                duration: 2000,
                easing: 'swing',
                step: function (now, tween) {
                    const formattedValue = Math.ceil(now).toLocaleString('en-US', { minimumFractionDigits: 0 });
                    const separatedValue = formattedValue.replace(/,/g, ' ');
                    $(this).text(separatedValue);
                }
            }
        );
    }

    init() {
        this.value = this.el.text();

        const formattedInitialValue = Math.ceil(this.value).toLocaleString('en-US', { minimumFractionDigits: 0 });
        const separatedInitialValue = formattedInitialValue.replace(/,/g, ' ');
        this.el.text(separatedInitialValue);

        this.initialWidth = this.el.width() + 5;
        this.el.css('width', this.initialWidth);
        this.el.css('display', 'inline-block');

        this.el.text(this.initialValue);

        this.window.on("scroll", () => {
            this.oTop = this.el.offset().top - window.innerHeight;
            if (!this.isRun && this.window.scrollTop() > this.oTop) {
                this.startAnimation()
            }
        })

    }
}

export default AnimatedCounter;